module.exports = __webpack_public_path__ + "media/images/athletes/1435-9056da82d5112e3b64d3a267563bb97c.png";